import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronRight, ChevronDown, FolderTree, FileText, Mail, Bookmark } from 'lucide-react';

// Flatten the tree iteratively so we don't render a recursive JSX component.
// Each row has depth so we can indent visually.
function flatten(roots, kids, expanded) {
  const rows = [];
  const walk = (nodes, depth) => {
    for (const n of nodes) {
      rows.push({ node: n, depth });
      if (expanded[n.id] && kids[n.id]?.length) walk(kids[n.id], depth + 1);
    }
  };
  walk(roots, 0);
  return rows;
}

const iconFor = (node) => {
  if (node.kind === 'folder') return FolderTree;
  if (node.kind === 'email_template') return Mail;
  if (node.kind === 'quick_ref') return Bookmark;
  return FileText;
};

export function KnowledgeTree({ roots, kids, currentId }) {
  const nav = useNavigate();
  // Root folders start expanded
  const [expanded, setExpanded] = useState(() => Object.fromEntries(roots.map(r => [r.id, true])));
  const toggle = (id) => setExpanded(e => ({ ...e, [id]: !e[id] }));
  const rows = flatten(roots, kids, expanded);

  return (
    <div>
      {rows.map(({ node, depth }) => {
        const hasChildren = (kids[node.id] || []).length > 0;
        const Icon = iconFor(node);
        const active = currentId === node.id;
        const open = !!expanded[node.id];
        return (
          <div
            key={node.id}
            className={`side-nav-item ${active ? 'active' : ''}`}
            style={{ paddingLeft: 8 + depth * 12 }}
            data-testid={`kn-tree-item-${node.id}`}
          >
            {hasChildren ? (
              <button onClick={() => toggle(node.id)} className="p-0.5 -ml-0.5" aria-label="toggle">
                {open ? <ChevronDown size={12} /> : <ChevronRight size={12} />}
              </button>
            ) : (
              <span className="w-3" />
            )}
            <Icon size={13} />
            <button onClick={() => nav(`/knowledge/${node.id}`)} className="truncate text-left flex-1">
              {node.title}
            </button>
          </div>
        );
      })}
    </div>
  );
}
